import { useQuery } from '@apollo/client';
import cx from 'classnames';
import {
  SUBMISSION_REVIEWS,
  SubmissionReviewItem,
} from '../../services/graphql/submissionReview.operations';
import { ossImage } from '../../utils/ossImage';

export const AssignmentReviewModal = ({
  submissionId,
  onClose,
}: {
  submissionId: string;
  onClose: () => void;
}): JSX.Element => {
  const { data, loading } = useQuery<{ submissionReviews: SubmissionReviewItem[] }>(
    SUBMISSION_REVIEWS,
    { variables: { submissionId } },
  );

  const reviews = (data?.submissionReviews ?? []).filter((review) => review.publishedAt);

  return (
    <div className="fullscreen-overlay z-[1000] flex items-center justify-center p-6">
      <div className="bg-white w-full max-w-2xl max-h-[80vh] overflow-auto rounded-lg p-6 relative">
        <button
          type="button"
          className="absolute top-4 right-4 text-2xl leading-none text-gray-500"
          onClick={onClose}
        >
          ×
        </button>
        <h2 className="text-xl font-semibold mb-4 pr-8">老师评语</h2>

        {loading && <div className="text-gray-500">加载中...</div>}

        {!loading && reviews.length === 0 && (
          <div className="text-gray-500">暂无评语内容</div>
        )}

        <div className="flex flex-col gap-4">
          {reviews.map((review) => (
            <div key={review.reviewId} className="border border-gray-200 rounded p-4">
              <div className="text-xs text-gray-500 mb-2">
                {review.authorRole === 'teacher' ? '任课教师' : '班主任'}
              </div>
              {review.comment && (
                <div className="text-sm whitespace-pre-wrap text-gray-800">{review.comment}</div>
              )}
              {review.mediaUrls?.length > 0 && (
                <div className="grid grid-cols-3 gap-2 mt-3">
                  {review.mediaUrls.map((url) => (
                    <img
                      key={url}
                      src={ossImage(url, { resize: { w: 320, m: 'mfit' } })}
                      alt=""
                      className="w-full aspect-square object-cover rounded"
                    />
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
